<template>
  <div class="fct-input-control">
    <button class="dropdown-toggle is-hidden-mobile" :class="{'toggle-opened': toggleOpened}"
            :disabled="disabled"
            @click="toggle()">
      <span v-text="value[label]"></span>
      <span v-if="value.length > 0" class="selected-categories">[<strong
        v-text="valueStr"></strong>]</span>
      <i class="fa fa-angle-up"></i>
    </button>
    <div class="fct-input is-hidden-tablet">
      <button class="dropdown-toggle"
              :class="{'toggle-opened': toggleOpened}" :disabled="disabled"
              @click="toggle()">
        <span v-text="value[label]"></span>
        <span v-if="value.length > 0" class="selected-categories">[<strong
          v-text="valueStr"></strong>]</span>
        <i class="fa fa-angle-up"></i>
      </button>
    </div>
    <div v-if="multiSelection">todo</div>
    <div v-else>
      <select-options v-if="toggleOpened"
                      @close="toggle"
                      @input="val => $emit('input', val)"
                      :value="value"
                      :label="label"
                      :options="items"
                      :multiple="multiSelection">
      </select-options>
<!--      <transition name="fade">-->
<!--        <ul ref="dropdownMenu" v-if="toggleOpened" class="dropdown-menu" :style="{ 'max-height': maxHeight }">-->
<!--          <li v-for="(option, index) in items" v-bind:key="index"-->
<!--              :class="{ active: isOptionSelected(option), highlight: index === typeAheadPointer }"-->
<!--              @mouseover="typeAheadPointer = index">-->
<!--            <a @mousedown.prevent="select(option)">-->
<!--              <slot name="option" v-bind="(typeof option === 'object')?option:{[label]: option}">-->
<!--                <img class="option-img" :src="option.imageUrl" alt="">-->
<!--                <span class="option-text option-label" v-text="option.label"></span>-->
<!--                <span class="option-text option-country-code">+{{option.countryCode}}</span>-->
<!--              </slot>-->
<!--            </a>-->
<!--          </li>-->
<!--          <li v-if="!filteredOptions.length" class="no-options">-->
<!--            <slot name="no-options">Sorry, no matching options.</slot>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </transition>-->
    </div>
  </div>
</template>

<script>
  import SelectOptions from "./FctSelect/components/SelectOptions";
  export default {
    props: ['disabled', 'label', 'value', 'items', 'multiSelection'],
    components: {SelectOptions},
    data() {
      return {
        toggleOpened: false
      }
    },
    methods: {
      toggle() {
        this.toggleOpened = !this.toggleOpened
      },
      isOptionSelected(option) {
        return option = this.value
      }
    },
    computed: {
      valueStr() {
        let {value} = this
        return this.multiSelection ? value.join(', ') : value
      }
    }
  }
</script>

<style scoped>
  .fct-input-control {


  }
</style>
